export const AUTH_SLICE_NAME = "auth"
